import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button, Table } from 'reactstrap';
import * as dailyLogActions from '../../actions/dailyLogActions';
import DailyLog from './DailyLog';
import AddDailyLogModal from './AddDailyLogModal';
import { getUserId } from '../../services/authService';
import { toast } from 'react-toastify';
import moment from 'moment';

class DailyLogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      dailyLogs: props.dailyLogs.sort(function (a, b) {
        return new Date(a.logDate) - new Date(b.logDate);
      }),
    };
  }

  componentWillMount() {
    this.props.actions.loadUserDailyLogs(getUserId());
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dailyLogs) {
      if (this.props.dailyLogs !== nextProps.dailyLogs) {
        this.setState({
          dailyLogs: nextProps.dailyLogs.sort(function (a, b) {
            return new Date(a.logDate) - new Date(b.logDate);
          }),
        });
      }
    }
  }

  datesMatch = (date, logs) => {
    let match = false;
    const parsedInputDate = moment(date).format('YYYY-MM-DD');
    logs.forEach(function (log) {
      const parsedDate = moment(log.logDate).format('YYYY-MM-DD');
      if (parsedInputDate === parsedDate) {
        match = true;
      }
    });
    return match;
  };

  createDailyLog = (logDate) => {
    const { dailyLogs } = this.props;
    const parsedLogDate = logDate;
    if (this.datesMatch(parsedLogDate, dailyLogs)) {
      toast.error('Log for date already exists');
      return;
    }
    const id = getUserId();
    this.props.actions
      .saveDailyLog(logDate, id)
      .then(() => {
        toast.success('Log created.');
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  render() {
    const { dailyLogs } = this.state;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Daily Logs</h1>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button
                className="primary mb-2"
                onClick={() => {
                  this.toggleModal();
                }}
              >
                Add
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {dailyLogs.length > 0 ? (
                <Table>
                  <thead>
                    <tr>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dailyLogs.map((dailyLog) => (
                      <DailyLog key={dailyLog.id} dailyLog={{ ...dailyLog }} />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <h4 className="mt-4">No logs found</h4>
              )}
            </Col>
          </Row>
          <AddDailyLogModal
            show={this.state.showModal}
            createDailyLog={this.createDailyLog}
            toggle={this.toggleModal}
          />
        </Container>
      </div>
    );
  }
}

DailyLogPage.propTypes = {
  dailyLogs: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    dailyLogs: state.dailyLogs,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(dailyLogActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DailyLogPage)
);



// WEBPACK FOOTER //
// ./src/components/daily-log/DailyLogPage.js